import { toRgba } from "../to-rgba/to-rgba.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/luminance/luminance.ts
function gammaCorrect(c) {
	return c <= .03928 ? c / 12.92 : ((c + .055) / 1.055) ** 2.4;
}
function getLightnessFromOklch(oklchColor) {
	const match = oklchColor.match(/oklch\((.*?)%\s/);
	return match ? parseFloat(match[1]) : null;
}
function luminance(color) {
	if (color.startsWith("oklch(")) return (getLightnessFromOklch(color) || 0) / 100;
	const { r, g, b } = toRgba(color);
	const sR = r / 255;
	const sG = g / 255;
	const sB = b / 255;
	const rLinear = gammaCorrect(sR);
	const gLinear = gammaCorrect(sG);
	const bLinear = gammaCorrect(sB);
	return .2126 * rLinear + .7152 * gLinear + .0722 * bLinear;
}
function isLightColor(color, luminanceThreshold = .179) {
	if (color.startsWith("var(")) return false;
	return luminance(color) > luminanceThreshold;
}
//#endregion
export { isLightColor, luminance };

//# sourceMappingURL=luminance.mjs.map